import React from "react";
import { InlineMath } from "react-katex";
import { makeSimpleClosedTask, normalizeMay2026Variant, pick, rationalLatex } from "../../../../matura/MaturaMay2026ClosedTaskSupport";

const VARIANTS = [{a:"2",av:2,x:1,y:5,b:3},{a:"-2",av:-2,x:2,y:-1,b:3},{a:"\\frac12",av:.5,x:4,y:3,b:1},{a:"-\\frac12",av:-.5,x:2,y:1,b:2},{a:"3",av:3,x:-1,y:1,b:4},{a:"-3",av:-3,x:1,y:-5,b:-2},{a:"\\frac13",av:1/3,x:3,y:2,b:1},{a:"-\\frac14",av:-.25,x:4,y:-3,b:-2}];

export function generateTask(options = {}) {
  const variant = normalizeMay2026Variant(options);
  const data = variant === "original" ? { a: "-\\frac13", av: -1/3, x: 2, y: -2, b: -4/3 } : pick(VARIANTS);
  const intercept = rationalLatex(data.b);
  const wrongIntercepts = [...new Set([
    data.y,
    data.x,
    -data.b,
    data.b + 1,
    data.b - 1,
    0,
  ])]
    .filter((value) => value !== data.b)
    .slice(0, 3)
    .map((value) => `(0,${rationalLatex(value)})`);
  return makeSimpleClosedTask({
    type: "MaturaParallelLineYAxisIntersectionClosedTask",
    taskNumber: "26",
    variant,
    prompt: <span>Prosta <InlineMath math="l"/> jest równoległa do prostej <InlineMath math={`y=${data.a}x+2`}/> i przechodzi przez punkt <InlineMath math={`(${data.x},${data.y})`}/>. Przecina oś <InlineMath math="Oy"/> w punkcie:</span>,
    correct: `(0,${intercept})`,
    wrong: wrongIntercepts,
    tags: ["geometria analityczna", "proste rownolegle"],
    explanationSteps: [
      { title: "Proste równoległe mają ten sam współczynnik kierunkowy.", latex: `l:y=${data.a}x+b` },
      { title: "Podstawiamy współrzędne punktu i wyznaczamy wyraz wolny.", latex: `${data.y}=${data.a}\\cdot${data.x}+b\\Longrightarrow b=${intercept}` },
    ],
  });
}

export { checkClosedAnswer as checkAnswer, renderClosedAnswer as renderAnswer, renderClosedExplanation as renderExplanation, renderClosedInput as renderInput, renderClosedTask as renderTask, renderClosedUserAnswer as renderUserAnswer } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
